import React from 'react';
import cx from 'classnames';

import T from 'Utilities/texts';

import { RoundedSection } from '../../../common/RoundedSection/RoundedSection';

import Avatar from './Avatar';
import teamList from './teamConfig';

import styles from './Team.scss';

const Team = React.memo(() => (
  <RoundedSection withTopLedge className={styles.teamBox}>
    <h2 className={styles.title}>
      {T.translate('aboutPage.team.title')}
    </h2>
    <p className={cx('mw-title-large', styles.description)}>
      {T.translate('aboutPage.team.description')}
    </p>
    <h3 className="mw-title-title3">
      {T.translate('aboutPage.team.subTitle')}
    </h3>
    <div className={styles.teamBg}>
      <div className={styles.inner}>
        {
          teamList.map((item) => <Avatar {...item} key={item.name} />)
        }
      </div>
    </div>
  </RoundedSection>
), () => true);

export default Team;
